import LogOutLink from "../LogOutLink";
import Layout from "./Layout";

export default function NotAnAdmin(): JSX.Element {
  return (
    <Layout title="Permission Required">
      <p>
        You haven't been added as an admin to this organization. Another admin
        will need to add you before you can access the dialer.
      </p>
      <LogOutLink />
    </Layout>
  );
}
